import { apiPost, apiGet } from './client';

export async function startScrapeJob(url, extras = {}) {
  return apiPost('/scrape', { url, ...extras });
}

export async function getScrapeStatus(jobId) {
  return apiGet(`/scrape/${jobId}`);
}

export async function listProfiles() {
  return apiGet('/scrape/list');
}
